import styled from '@emotion/styled';

export const Wrapper = styled.button`
  width: 100%;
  background-color: ${({ theme }) => theme.colors.neutral[700]};
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 40px;
  height: 50px;
  transition: all 0.2s ease;
  cursor: pointer;

  &:hover {
    box-shadow: 5px 10px 20px 0 rgba(0, 0, 0, 0.1);
  }
`;

export const Label = styled.span`
  font-size: 16px;
  font-weight: normal;
  color: ${({ theme }) => theme.colors.neutral[0]};
`;
